"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.oneTimeFormConf = exports.addOnsFormConf = exports.analyserFormConf = void 0;
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/Benchmarks/constants");
var constants_2 = require("containers/TableMaker/constants");
var AddOnsSelect_1 = __importDefault(require("./CellComponents/AddOnsSelect"));
var AddOnsSubtotal_1 = __importDefault(require("./CellComponents/AddOnsSubtotal"));
var AddRow_1 = __importDefault(require("./CellComponents/AddRow"));
var BillingCycleSelect_1 = __importDefault(require("./CellComponents/BillingCycleSelect"));
var OneTimeQuote_1 = __importDefault(require("./CellComponents/OneTimeQuote"));
var OneTimeSubtotal_1 = __importDefault(require("./CellComponents/OneTimeSubtotal"));
var PlanSelect_1 = __importDefault(require("./CellComponents/PlanSelect"));
var PlanTierSelect_1 = __importDefault(require("./CellComponents/PlanTierSelect"));
var RemoveRowBtn_1 = __importDefault(require("./CellComponents/RemoveRowBtn"));
var RenewalFrequencySelect_1 = __importDefault(require("./CellComponents/RenewalFrequencySelect"));
var Subtotal_1 = __importDefault(require("./CellComponents/Subtotal"));
var UnitsTextfield_1 = __importDefault(require("./CellComponents/UnitsTextfield"));
var VendorQuoteTextfield_1 = __importDefault(require("./CellComponents/VendorQuoteTextfield"));
var XL = constants_2.CellSize.XL, LG = constants_2.CellSize.LG, MD = constants_2.CellSize.MD, SM = constants_2.CellSize.SM;
exports.analyserFormConf = {
    headersMap: {
        plan: 'Plans',
        renewalFrequencies: 'Renewal',
        billingCycles: 'Billing',
        subtotal: 'Sub-total (RRP)',
    },
    row: {
        isTitle: false,
    },
    footer: { cellProps: { border: 'none', height: 80, lineHeight: '80px' } },
    cells: [
        {
            cell: { width: XL, isFlexCenter: true, offset: 'right' },
            truncate: {},
            field: 'plan',
            renderComponent: PlanSelect_1.default,
            stopPropagation: true,
            footerAggregate: 'count',
            footerAggregateRenderValue: AddRow_1.default,
            noSort: true,
        },
        {
            cell: { width: LG, isFlexCenter: true, offset: 'right' },
            field: 'tier',
            renderComponent: PlanTierSelect_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: MD, isFlexCenter: true, offset: 'right' },
            field: 'renewalFrequencies',
            renderComponent: RenewalFrequencySelect_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: MD, isFlexCenter: true, offset: 'right' },
            field: 'billingCycles',
            renderComponent: BillingCycleSelect_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: XL, isFlexCenter: true, textAlign: 'right', offset: 'right' },
            field: 'units',
            renderComponent: UnitsTextfield_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: {
                width: MD,
                isFlexCenter: true,
                textAlign: 'right',
                offset: 'left',
                fontWeight: 'bold',
            },
            field: 'subtotal',
            renderComponent: Subtotal_1.default,
            footerAggregate: 'sum',
            noSort: true,
            money: { isRounded: true },
        },
        { cell: { width: MD, isActionCell: true }, noSort: true },
        {
            cell: { width: LG, isFlexCenter: true, textAlign: 'right', offset: 'left' },
            field: 'vendorQuote',
            renderComponent: VendorQuoteTextfield_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: SM, isActionCell: true, isFlexCenter: true }, key: 'removeRow', renderComponent: RemoveRowBtn_1.default,
        },
    ],
};
exports.addOnsFormConf = {
    footer: { cellProps: { border: 'none', height: 80, lineHeight: '80px' } },
    cells: [
        {
            cell: { width: XL, isFlexCenter: true, offset: 'right' },
            truncate: {},
            field: 'plan',
            renderComponent: AddOnsSelect_1.default,
            stopPropagation: true,
            footerAggregate: 'count',
            footerAggregateRenderValue: AddRow_1.default,
            noSort: true,
        },
        {
            cell: { width: LG }, noSort: true,
        },
        {
            cell: { width: MD, isFlexCenter: true, offset: 'right' },
            field: 'renewalFrequencies',
            renderComponent: RenewalFrequencySelect_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: MD, isFlexCenter: true, offset: 'right' },
            field: 'billingCycles',
            renderComponent: BillingCycleSelect_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: XL, isFlexCenter: true, textAlign: 'right', offset: 'right' },
            field: 'units',
            renderComponent: UnitsTextfield_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: {
                width: MD, isFlexCenter: true, textAlign: 'right', offset: 'left', fontWeight: 'bold',
            },
            field: 'subtotal',
            renderComponent: AddOnsSubtotal_1.default,
            footerAggregate: 'sum',
            noSort: true,
            money: { isRounded: true },
        },
        { cell: { width: MD, isActionCell: true }, noSort: true },
        {
            cell: { width: LG, isFlexCenter: true, offset: 'left' },
            field: 'vendorQuote',
            renderComponent: VendorQuoteTextfield_1.default,
            stopPropagation: true,
            noSort: true,
        },
        {
            cell: { width: SM, isActionCell: true, isFlexCenter: true }, key: 'removeRow', renderComponent: RemoveRowBtn_1.default,
        },
    ],
};
exports.oneTimeFormConf = {
    extractors: {
        plan: function (item) {
            var _a;
            var tier = (0, end2end_1.getRowFamilyAndTier)(constants_1.HUBSPOT_SERVICE_PLANS)(item).tier; // should be in a context?
            return (_a = tier === null || tier === void 0 ? void 0 : tier.oneTimeFee) === null || _a === void 0 ? void 0 : _a.name;
        },
        tier: function (item) { return item.oneTimeQuote || 'One time fees'; },
        oneTimeRenewal: function () { return 1; },
    },
    footer: { cellProps: { border: 'none', height: 80, lineHeight: '80px' } },
    cells: [
        { field: 'plan', cell: { width: XL }, truncate: {}, noSort: true },
        { key: 'empty-2', cell: { width: LG }, noSort: true },
        { field: 'oneTimeRenewal', cell: { width: MD, offset: 'right' }, noSort: true },
        { key: 'empty-1', cell: { width: MD, offset: 'right' } },
        { key: 'empty0', cell: { width: XL, offset: 'right' } },
        {
            field: 'oneTimeFee',
            cell: {
                width: MD,
                isFlexCenter: true,
                textAlign: 'right',
                offset: 'left',
                fontWeight: 'bold',
            },
            renderComponent: OneTimeSubtotal_1.default,
            footerAggregate: 'sum',
            noSort: true,
            money: { isRounded: true },
        },
        { key: 'empty', cell: { width: MD, isActionCell: true } },
        {
            field: 'oneTimeQuote',
            cell: { width: LG, isFlexCenter: true, offset: 'left' },
            renderComponent: OneTimeQuote_1.default,
            stopPropagation: true,
            noSort: true,
        },
        { key: 'empty2', cell: { width: SM, isActionCell: true } },
    ],
};
